import axiosInstance from '@/utils/api.js'

var state = {
  archiveDB: [],
  archiveDBScheduled: []
}

var getters = {
  ARCHIVE_DB: (state) => {
    return state.archiveDB
  },
  ARCHIVE_DB_SCHEDULE: (state) => {
    return state.archiveDBScheduled
  }
}

var mutations = {
  SET_ARCHIVE_DB: (state, payload) => {
    state.archiveDB = payload
  },
  SET_ARCHIVE_DB_SCHEDULED: (state, payload) => {
    state.archiveDBScheduled = payload
  }
}

var actions = {
  GET_ARCHIVE_DB: async (context, payload) => {
    let result = await axiosInstance.get('/settings/db_archives')
    if (result.status === 200) {
      context.commit('SET_ARCHIVE_DB', result.data)
    }
  },
  CREATE_ARCHIVE_DB: (context, payload) => {
    return axiosInstance.post('/settings/db_archives')
  },
  CREATE_ARCHIVE_DB_REMOTE: (context, payload) => {
    return axiosInstance.post('/settings/db_archives_with_connection')
  },
  CREATE_ARCHIVE_DB_SCHEDULE: (context, payload) => {
    return axiosInstance.post('/settings/db_archives_schedule', payload)
  },
  GET_ARCHIVE_DB_SCHEDULE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/db_archives_schedule')
    if (result.status === 200) {
      context.commit('SET_ARCHIVE_DB_SCHEDULED', result.data)
    }
  },
  DELETE_ARCHIVE_DB_SCHEDULE: (context, payload) => {
    return axiosInstance.delete('/settings/db_archives_schedule?archive_id=' + payload)
  },
  UPDATE_ARCHIVE_DB: (context, payload) => {
    return axiosInstance.get('/settings/db_archives_update')
  },
  TEST_DB_CONN: (context, payload) => {
    return axiosInstance.put('/settings/test_db_connection', payload)
  },
  VERIFY_ARCHIVE_DB: (context, payload) => {
    return axiosInstance.get('/settings/db_archives_verify')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/archiveDB.js